/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgEmailQuote64(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={64}
      height={64}
      fill='none'
      viewBox='0 0 64 64'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M2 16.5h53l-1 .924V18.5h-1.164l-16.86 15.589 13.243 13.716-1.438 1.39-13.274-13.748-3.634 3.36c-1.288 1.176-3.447 1.185-4.746 0l-3.634-3.36L9.22 49.195l-1.438-1.39L21.025 34.09 4.163 18.5H4v34h49v-19h2v21H2v-38zm47.89 2H7.11c6.805 6.292 13.422 12.793 20.416 18.875.551.468 1.433.46 1.975-.024L49.89 18.5z'
      />
      <path
        fill='#007BB3'
        fillRule='evenodd'
        d='M52.5 9c5.243 0 9.5 4.257 9.5 9.5S57.743 28 52.5 28 43 23.743 43 18.5 47.257 9 52.5 9z'
      />
    </svg>
  );
}

export default SvgEmailQuote64;
